import styles from './Footer.module.scss';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <p className={styles.copyright}>
        © {currentYear} CHERRY FULLTHROTTLE TECHSOFT PRIVATE LIMITED. All rights reserved.
      </p>
      <nav className={styles.links} aria-label="Footer navigation">
        <a href="#privacy"  className={styles.link}>Privacy Policy</a>
        <span className={styles.dot} aria-hidden="true" />
        <a href="#terms"    className={styles.link}>Terms of Service</a>
        <span className={styles.dot} aria-hidden="true" />
        <a href="#support"  className={styles.link}>Support</a>
      </nav>
    </footer>
  );
};

export default Footer;
